const FormRules = {
  required: (v) => !!v || 'Field is required',
};

export { FormRules };
